import type { Component } from '../../schemas/validation';

/**
 * Insert a component into a layout's component list at an optional index.
 */
export function insertComponentAtPosition(
  components: Component[],
  newComponent: Component,
  insertPosition: number | null
): Component[] {
  if (insertPosition !== null) {
    const updated = [...components];
    updated.splice(insertPosition, 0, newComponent);
    return updated.map((c, idx) => ({ ...c, order: idx }));
  }

  return [...components, { ...newComponent, order: components.length }];
}
